import * as i from 'types';
import * as React from 'react';

export const useSaveUser = (): {
  saveUser: (id: string, data: Partial<i.SavedDataType>, method: i.SaveMethods) => Promise<void>;
  isLoading: boolean;
} => {
  const [isLoading, setIsLoading] = React.useState(false);

  const saveUser = async (
    id: string, data: Partial<i.SavedDataType>, method: i.SaveMethods = 'PUT',
  ) => {
    setIsLoading(true);
    try {
      await fetch(`${import.meta.env.VITE_API_URL}/saveUser`, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': import.meta.env.VITE_APP_API_KEY,
        },
        body: JSON.stringify(data),
      });
    } catch (error) {
      // Silent error handling - log for debugging but don't notify user
      if (error instanceof Error) {
        console.error(`Error saving user: ${error.message}`);
      } else {
        console.error('Unknown error occurred while saving user');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return { saveUser, isLoading };
};
